<template>
  <RModal ref="modal" :title="modalTitle" full-size no-footer :persistent="false" :loading="loadingEmail">
    <EmailBatchDisplay v-if="email" :email="email" />
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import RModal from '@/ui/RModal'
import EmailBatchDisplay from '@components/lm-blocks/EmailBatchDisplay'

export default {
  components: {
    RModal,
    EmailBatchDisplay
  },

  data: () => ({
    emails: {},
    loadingEmail: false,
    emailId: null
  }),

  computed: {
    email() {
      if (!this.emailId) return null

      return this.emails[this.emailId]
    },

    modalTitle() {
      return this.email?.subject ?? 'Retrieving data...'
    }
  },

  methods: {
    show(emailId) {
      if (!!this.emails[emailId]) {
        this.emailId = emailId
        this.$refs.modal.show()
      } else {
        this.emailId = null
        this.loadingEmail = true
        this.$refs.modal.show()
        apiTo
          .GET_EMAIL(emailId)
          .then(({ data }) => {
            this.emails[emailId] = data.result
            this.emailId = data.result.id
          })
          .finally(() => (this.loadingEmail = false))
      }
    }
  }
}
</script>
